import { useRef } from 'react';
import type { TouchEvent } from 'react';
import type { LeadTab, ShootTab } from './useShootTab';

/**
 * Swiping sideways on the content switches tabs (mock-up §04). Touch start
 * and end deltas only: no library, and nothing that could fight the page's
 * vertical scroll, since a swipe only counts when it is clearly horizontal.
 */

const MIN_DISTANCE = 60;

export function useSwipeTabs(
  active: ShootTab,
  onChange: (tab: ShootTab) => void,
  lead: LeadTab = 'brief',
) {
  const start = useRef<{ x: number; y: number } | null>(null);

  return {
    onTouchStart(e: TouchEvent<HTMLElement>) {
      const touch = e.touches[0];
      start.current = touch ? { x: touch.clientX, y: touch.clientY } : null;
    },
    onTouchEnd(e: TouchEvent<HTMLElement>) {
      const from = start.current;
      const touch = e.changedTouches[0];
      start.current = null;
      if (!from || !touch) return;
      const dx = touch.clientX - from.x;
      const dy = touch.clientY - from.y;
      if (Math.abs(dx) < MIN_DISTANCE || Math.abs(dx) <= Math.abs(dy)) return;
      // Swiping left pulls the right-hand tab in, and the reverse.
      const next: ShootTab = dx < 0 ? 'questions' : lead;
      if (next !== active) onChange(next);
    },
  };
}
